import { StaffSessionUser } from "../models/StaffSessionUser.js";
import { ViewModel } from "../mvvm/ViewModel.js";
/** Signed-in staff user, derived from the access token. */
export class StaffSessionViewModel extends ViewModel {
    client;
    identity;
    constructor(client, identity) {
        super({ user: null });
        this.client = client;
        this.identity = identity;
    }
    /** Re-reads the token; null when signed out. */
    check() {
        const claims = this.client.claims();
        const user = claims?.sub ? StaffSessionUser.fromClaims(claims, this.identity.recall()) : null;
        this.setState({ user });
        return user;
    }
    /** Call after a successful sign-in with the name the person typed. */
    signedIn(typedName) {
        const name = typedName.trim() || this.identity.resolveEmail(typedName).split("@")[0] || "";
        if (name)
            this.identity.remember(name);
        return this.check();
    }
    signOut() {
        this.client.logout();
        this.identity.forget();
        this.setState({ user: null });
    }
}
//# sourceMappingURL=StaffSessionViewModel.js.map